(function($){
    'use strict';

    
}(jQuery));